import { useMemo } from "react";
import useCurrentUser from "../../hooks/useCurrentUser";
import { ValuesType } from "../../types/date";

const useAvailabilities = () => {
  const { availabilities } = useCurrentUser();

  const values: ValuesType = useMemo(() => availabilities.reduce((result: any, current) => {
    if (!result[current.day]) {
      result[current.day] = {};
    }

    const day = result[current.day];

    if (day.list) {
      result[current.day].list.push({
        id: current.id,
        data: [+current.time_from.split(":")[0], +current.time_to.split(":")[0]]
      });
    } else {
      result[current.day].list = [{
        id: current.id,
        data: [+current.time_from.split(":")[0], +current.time_to.split(":")[0]]
      }];
    }

    return result;
  }, {}), [availabilities]);

  return {
    values
  };
};

export default useAvailabilities;
